<template>
  <div class="statistics mb30">
    <div>
      <div>
        <img src="@/assets/techstatistic/statics.png" alt="" style="width: 100%;border-radius: 15px;">
      </div>
      <div class="contents mt40">
        <!-- <h3><i class="fa fa-file-text fa-fw" /> Dual-omics  Profiling Techniques</h3> -->
        <h3>Dual-omics  Profiling Techniques</h3>
        <el-divider></el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <h4>RNA-seq Transcriptomics for Spatiotemporal Gene Expression Profiling</h4>
            <div>
              To capture the spatial and temporal dynamics of gene expression during early Xenopus development, we performed high-resolution RNA sequencing (RNA-seq) across six critical embryonic stages. By systematically cryo-sectioning embryos along the animal-vegetal axis into 707 discrete sections, we generated a comprehensive transcriptomic atlas encompassing over 31,000 genes. This fine-scale RNA-seq profiling enabled the mapping of gene expression patterns with subcellular spatial resolution, providing an essential resource for decoding early developmental gene regulatory networks.
            </div>
          </el-col>
          <el-col :span="12">
            <h4>MS-based Proteomics for Spatially Resolved Protein Quantification</h4>
            <div>
              Complementing the transcriptomic analysis, we applied mass spectrometry (MS)-based proteomics to profile protein distribution across the same six embryonic stages. Through systematic cryo-sectioning of embryos into 692 sections and subsequent quantitative proteomic analysis, we identified and quantified 8,642 proteins. This spatial proteomics approach provided a detailed landscape of protein localization patterns at subcellular resolution, enabling the study of protein dynamics, spatial polarity, and co-localization during early embryogenesis.
            </div>
          </el-col>
        </el-row>
        <div class="mt40">
          <!-- <h3><i class="el-icon-s-data" /> Profiled Data Statistic</h3> -->
          <h3>Profiled Data Statistic</h3>
          <el-divider></el-divider>
          <el-row :gutter="20" class="mt20">
            <el-col :span="8" class="textCenter">
              <h4>Feature numbers for protein and mRNA by stage</h4>
              <img src="@/assets/techstatistic/1.jpg" alt="" style="width: 100%;" class="mt10">
            </el-col>
            <el-col :span="8" class="textCenter">
              <h4>mRNA count in sections</h4>
              <img src="@/assets/techstatistic/2.jpg" alt="" style="width: 100%;" class="mt10">
            </el-col>
            <el-col :span="8" class="textCenter">
              <h4>Protein count in sections</h4>
              <img src="@/assets/techstatistic/3.jpg" alt="" style="width: 100%;" class="mt10">
            </el-col>
          </el-row>
          <!-- <div class="mt20">
            <img src="@/assets/techstatistic/statics3.png" alt="" style="width: 100%;">
          </div> -->
          <!-- <el-row :gutter="20" class="mt20">
            <el-col :span="8" class="textCenter">
              <h4>S4 Subcellular lntersection Proportions</h4>
              <img src="@/assets/techstatistic/4.jpg" alt="" style="width: 100%;" class="mt10">
            </el-col>
            <el-col :span="8" class="textCenter">
              <h4>S4 Subcellular lntersection Proportions</h4>
              <img src="@/assets/techstatistic/5.jpg" alt="" style="width: 100%;" class="mt10">
            </el-col>
            <el-col :span="8" class="textCenter">
              <h4>S4 Subcellular lntersection Proportions</h4>
              <img src="@/assets/techstatistic/6.jpg" alt="" style="width: 100%;" class="mt10">
            </el-col>
          </el-row>
          <el-row :gutter="20" class="mt20">
            <el-col :span="8" class="textCenter">
              <h4>Egg Subcellular lntersection Proportions</h4>
              <img src="@/assets/techstatistic/7.jpg" alt="" style="width: 100%;" class="mt10">
            </el-col>
            <el-col :span="8" class="textCenter">
              <h4>EZ Subcellular lntersection Proportions</h4>
              <img src="@/assets/techstatistic/8.jpg" alt="" style="width: 100%;" class="mt10">
            </el-col>
            <el-col :span="8" class="textCenter">
              <h4>LZ Subcellular lntersection Proportions</h4>
              <img src="@/assets/techstatistic/9.jpg" alt="" style="width: 100%;" class="mt10">
            </el-col>
          </el-row> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {  } from '@/api'
  export default {
    name: 'statistics',
    data() {
      return {
        
      };
    },
    computed: {},
    mounted() {
    },
    created() {
      
    },
    watch: {

    },
    methods: {
    },
  };
</script>
<style lang="scss" scoped>
  .statistics {
    background: #ffffff;
    padding: 20px;
    width: 80%;
    margin: auto;
    .contents {
      h3 {
        color: #17754a;
      }
    }
  }
</style>
